import React from "react";

const Banner = ({ properties, data, icons }) => {
  return (
    <div className="grid-box">
      {properties?.map((property, index) => (
        <div key={index} className="section-box">
          <div className={`grid-img ${icons[index]}`} />
          <p className="grid-num">{data[index] ?? "-"}</p>
          <p className="grid-title">{property}</p>
        </div>
      ))}
    </div>
  );
};

export default Banner;
